import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const StyledLink = styled(NavLink)`
  color: inherit;
  text-decoration: none;
  height: 100%;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: ${({ theme }) => theme.DIMENSIONS.HEADER_HEIGHT};
  border-bottom: 5px solid ${({ theme }) => theme.COLORS.TRANSPARENT};
  text-transform: uppercase;

  &.active {
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  }
`;

export default StyledLink;
